export default __webpack_public_path__ + "static/id-fraud-img-2-5d5725b0defe9dc81c8ed4163b6a5a55.svg";